document.addEventListener('ShoptetCartUpdated', function () {
});
document.addEventListener('ShoptetDOMContentLoaded', function () {
    categoryInit();
});

document.addEventListener('shoptet.products.sameHeightOfProducts', function () {
});

document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function () {
});

document.addEventListener('ShoptetDOMPageContentLoaded', function () {
    categoryInit();
});

document.addEventListener('ShoptetPagePaginationUsed', function () {
    categoryInit();
});

document.addEventListener('ShoptetPageSortingChanged', function () {
    categoryInit();
});

document.addEventListener('ShoptetPageFiltersRecalledFromHistory', function () {
    categoryInit();
});

document.addEventListener('ShoptetPagePriceFilterChange', function () {
    categoryInit();
});

document.addEventListener('ShoptetPageFilterValueChange', function () {
    categoryInit();
});

document.addEventListener('ShoptetPageFiltersCleared', function () {
    categoryInit();
});

document.addEventListener('ShoptetPageMoreProductsRequested', function () {
    categoryInit();
});